/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約検索情報
 */
export interface Szma102aRequestCtrSearchInfo {
    /**
     * 契約お客さま番号リスト：数字
     */
    firstSrvctrNoList?: Array<string>;
    /**
     * サービス種別コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C008410」のユーザコードを設定
     */
    srvClsfyCode?: string;
    /**
     * プロダクト種別区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C011300」のユーザコードを設定
     */
    prdClsfyDiv?: string;
    /**
     * プロダクトコードリスト：英数字
     */
    prdCodeList?: Array<string>;
    /**
     * 販売形態コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300020」のユーザコードを設定
     */
    salfrmCode?: string;
    /**
     * 中継店内部お客さま番号：数字
     */
    rlyisdVisitNo?: string;
    /**
     * 契約開始日付（ＦＲＯＭ）：日付(yyyyMMdd)
     */
    ctrefctkiStrtdateFrom?: string;
    /**
     * 契約開始日付（ＴＯ）：日付(yyyyMMdd)
     */
    ctrefctkiStrtdateTo?: string;
    /**
     * 請求確定番号リスト：数字
     */
    claimFixNoList?: Array<string>;
    /**
     * 契約者内部お客さま番号：数字
     */
    visitNo?: string;
    /**
     * 契約者お客さまカナ氏名：全角（カナ/数字/英字/スペース/記号）
     */
    visitKanaName?: string;
    /**
     * 使用お客さま番号リスト：数字
     */
    logicDeviceNoList?: Array<string>;
    /**
     * 外部接続番号リスト：英数字
     */
    extCnnctNoList?: Array<string>;
    /**
     * 契約状況：英数字<br>　コード変換マスターテーブル.画面項目ID「D400010」のユーザコードを設定
     */
    ctrStatus: string;
    /**
     * カスタマイズ検索条件エリア
     */
    additionalCondition?: object | null;
}

